import { render, staticRenderFns } from "./RegisterDriver.vue?vue&type=template&id=556f9f60"
import script from "./RegisterDriver.vue?vue&type=script&lang=js"
export * from "./RegisterDriver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports